import { Vue } from 'vue-property-decorator';

export default {
  getDomain(context: Vue): string {
    const hostname = window.location.hostname;
    const splitHostname = hostname.split(".");

    return "." + splitHostname[splitHostname.length - 2] + "." + splitHostname[splitHostname.length - 1];
  },

  getMainDomain(context: Vue): string {
    const hostname = window.location.hostname;
    const splitHostname = hostname.split(".");

    return "." + splitHostname[splitHostname.length - 1];
  },

  redirectToHome(context: Vue, redirectUrl?: string): void {
    if (context.$router.currentRoute.path.startsWith('/steam') ||
      context.$router.currentRoute.path.startsWith('/twitch') ||
      context.$router.currentRoute.path.startsWith('/epic-games')) {
      const redirect = document.location.origin + context.$route.fullPath;
      this.redirectToLogin(context, redirect);
    }

    if (context.$data.RCEnvironment.VUE_APP_ENVIRONMENT == "FOCUS") {
      if (context.$router.currentRoute.query.redirectUrl != null) {
        if (localStorage.getItem("focus_state") == null) {
          localStorage.setItem("focus_state", context.$router.currentRoute.query.redirectUrl.toString());
        }
      }
    }

    if (context.$router.currentRoute.path.startsWith('/account')) {
      if (redirectUrl == null) {
        context.$router.push({ name: 'Home' });
      }
      else {
        context.$router.push({ name: 'Home', query: { 'redirectUrl': redirectUrl } });
      }
    }
  },

  redirectToLogin(context: Vue, redirectUrl?: string): void {
    if (redirectUrl == null) {
      context.$router.push({ name: 'Login' });
    }
    else {
      context.$store.dispatch("updateRedirectUrl", redirectUrl);
      context.$router.push({ name: 'Login', query: { 'redirectUrl': redirectUrl } });
    }
  },

  redirectToAccount(context: Vue, checkUrl: boolean = false, redirect: boolean = false): void {
    if ((context.$router.currentRoute.path.startsWith('/oauth') && !context.$router.currentRoute.path.startsWith('/oauth/partner')) || context.$router.currentRoute.path.startsWith('/errors')) {
      return;
    }

    const redirectUrl = localStorage.getItem("g2g_redirect_url");
    if (redirectUrl && redirectUrl.includes("newsletter")) {
      localStorage.removeItem("g2g_redirect_url")
      context.$router.push({ name: 'Newsletter' });
    }

    if (redirect) {
      context.$router.push({ name: 'Information' });
    }
    else if (checkUrl && !context.$router.currentRoute.path.startsWith('/account') &&
      !context.$router.currentRoute.path.startsWith('/steam') &&
      !context.$router.currentRoute.path.startsWith('/epic-games') &&
      !context.$router.currentRoute.path.startsWith('/twitch') &&
      !context.$router.currentRoute.path.startsWith('/survey')) {
      context.$router.push({ name: 'Information' });
    }
    else if (!checkUrl && context.$router.currentRoute.path.startsWith('/epic-games/callback') ||
      context.$router.currentRoute.path.startsWith('/twitch/callback') ||
      context.$router.currentRoute.path.startsWith('/steam/callback')) {
      context.$router.push({ name: 'LinkAccount' });
    }
    else if (!checkUrl && !context.$router.currentRoute.path.startsWith('/account')) {
      context.$router.push({ name: 'Information' });
    }
  },

  getUrlWithUtm(environmentName: string, url: string): string {
    if (environmentName != "FOCUS") {
      return url;
    }

    const utmQueryParams = localStorage.getItem("utm_query_params");
    if (utmQueryParams != null) {
      const splittedParams = utmQueryParams.split(",");
      splittedParams.forEach(param => {
        if (!url.includes("?")) {
          url = [url, param].join("?");
        } else {
          url = [url, param].join("&");
        }
      });

      localStorage.removeItem("utm_query_params");
    }

    return url;
  }
}
